import { SectionMods } from '~components/Section/Section.types';
import { SectionEvent } from '~components/SectionEvent/SectionEvent';
import { TitleBacklightColors } from '~containers/MainPage/HeaderSection/HeaderSection.types';
import { MainPageProps } from '~containers/MainPage/MainPage.types';
import { Section2Cards } from '~containers/MainPage/Section2Cards/Section2Cards';
import { Section3Cards } from '~containers/MainPage/Section3Cards/Section3Cards';
import { Section4Cards } from '~containers/MainPage/Section4Cards/Section4Cards';
import { SectionNews } from '~containers/MainPage/SectionNews/SectionNews';
import { SectionReadOften } from '~containers/MainPage/SectionReadOften/SectionReadOften';
import { SectionRecent } from '~containers/MainPage/SectionRecent/SectionRecent';
import { SectionTopic } from '~containers/MainPage/SectionTopic/SectionTopic';
import {
  CommonBlockComponent,
  MainPageBlockComponent,
} from '~types/BlockComponent.types';

export const mapBlocksToJSX = (
  blocks: NonNullable<MainPageProps['blocks']>,
) => {
  return blocks.map((block, key) => {
    if (!block) return null;

    const additionalSectionMods: SectionMods[] = [];

    if (key === 0) {
      additionalSectionMods.push(SectionMods.Top);
    }
    if (key === blocks.length - 1) {
      additionalSectionMods.push(SectionMods.Bottom);
    }

    switch (block.component) {
      case MainPageBlockComponent.SectionTopic:
        return (
          <SectionTopic
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.Section2Cards:
        return (
          <Section2Cards
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.Section3Cards:
        return (
          <Section3Cards
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.Section4Cards:
        return (
          <Section4Cards
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.SectionNews:
        return (
          <SectionNews
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.SectionReadOften:
        return (
          <SectionReadOften
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case MainPageBlockComponent.SectionRecent:
        return (
          <SectionRecent
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      case CommonBlockComponent.SectionEvent:
        return (
          <SectionEvent
            {...block}
            key={key}
            mods={[SectionMods.SeparatorL, ...additionalSectionMods]}
          />
        );
      default:
        return undefined;
    }
  });
};

export const getTitleBacklightHex = (titleBacklight: TitleBacklightColors) => {
  switch (titleBacklight) {
    case TitleBacklightColors.Blue:
      return 'var(--modes-background-other-accent-themed)';
    case TitleBacklightColors.Magenta:
      return 'var(--modes-background-accent-accent-tertiary, #FF3985)';
    case TitleBacklightColors.DarkMint:
      return 'var(--modes-content-accent-accent-secondary)';
    case TitleBacklightColors.SecondaryBlue:
      return 'var(--modes-background-other-accent-themed)';
  }
};
